import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import './AMDashboardContainer.less';
import { Card, Container, Grid, Label } from 'semantic-ui-react';
import { Calendar } from 'react-date-range';
import DGTextbox from 'components/FormControls/Textbox/DGTextbox';
import Formsy from 'formsy-react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import moment from 'moment';
import { unassignRequestFromManager, getManagerAMDashboardData } from 'services/Manager';
import _ from 'lodash';
import { checkManagerAuthorization } from 'helpers/authorization';
import { REQUEST_ASSIGNMENT } from 'constants/FeaturesList';
import { SocketContext } from '../../context/socket';
import {
  ASSIGN_REQUEST_TO_MANAGER, UNASSIGN_REQUEST_FROM_MANAGER,
  UPDATE_MANAGER_ASSIGNED_REQUEST, SEND_INCOMING_MESSAGE_TO_AM_DASHBOARD
} from 'constants/socketIOListener';
import 'react-notifications/lib/notifications.css';
import { NotificationManager } from 'react-notifications';
import messageNotification from '../../assets/sounds/newMessage.mp3'
import requestAssignmentNotification from '../../assets/sounds/requestAssignment.mp3'
import ManagerRequestAssignmentHistory from '../../components/ManagerRequestAssignmentHistory/ManagerRequestAssignmentHistory';

const initialState = {
  showDatePicker: false,
  date: moment().toDate(),
  minDate: moment().subtract(1, "months").toDate(),
  momentDate: moment(),
  disableShowButton: false,
  assignmentList: {},
  orignalAssignmentList: [],
  assignmentEnabled: false,
  fetchedRecords: false,
  allMessagesFeed: [],
  newAssignRequest: undefined,
  loadHistoryData: true
}
class AMDashboardContainer extends Component {
  static contextType = SocketContext
  constructor(props) {
    super(props);
    this.state = initialState;

    this.txtBoxRef = createRef();
    this.refreshTimer = null;
  }
  async componentDidMount() {

    const socket = this.context
    this.setState({ assignmentEnabled: checkManagerAuthorization(REQUEST_ASSIGNMENT, this.props.currentUser) })
    await this.onValidFormSubmit();

    this.implementWebSockets(socket);

    document.addEventListener('mousedown', this.handleClickOutside);
    this.txtBoxRef = createRef();
    this.refreshTimer = null;
  }

  implementWebSockets = (socket) => {
    let key = ASSIGN_REQUEST_TO_MANAGER.replace("<MANAGER_USER_ID>", this.props.currentUser.userID);
    socket.on(key, (data) => {
      let newSbr = data.sbrDetail;
      if (newSbr) {
        let orignalAssignmentList = this.state.orignalAssignmentList;
        let existingSBR = orignalAssignmentList.find((al) => al.singleBuyerRequestID == newSbr.singleBuyerRequestID);
        if (!existingSBR) {
          orignalAssignmentList.push(newSbr);
          this.setState({
            orignalAssignmentList: orignalAssignmentList,
            assignmentList: this.generateAssignmentListData(orignalAssignmentList),
            newAssignRequest: { ...newSbr }
          }, () => {
            document.getElementById("main-page-panel-id").click();
            window.focus();
            setTimeout(() => {
              NotificationManager.success("New request assigned to you.", '', 700);
              const audio = new Audio(requestAssignmentNotification);
              audio.play();
            }, 100);     
          })
        }
      }
    })

    key = UNASSIGN_REQUEST_FROM_MANAGER.replace("<MANAGER_USER_ID>", this.props.currentUser.userID);
    socket.on(key, (data) => {
      let sbr = data.sbrDetail;
      if (sbr) {
        let orignalAssignmentList = this.state.orignalAssignmentList;
        let existingSBROrignalIndex = orignalAssignmentList.findIndex((al) => al.singleBuyerRequestID == sbr.singleBuyerRequestID);
        if (existingSBROrignalIndex != -1) {
          orignalAssignmentList.splice(existingSBROrignalIndex, 1);
          this.setState({ orignalAssignmentList: orignalAssignmentList, assignmentList: this.generateAssignmentListData(orignalAssignmentList) });
        }
      }
    })

    key = UPDATE_MANAGER_ASSIGNED_REQUEST.replace("<MANAGER_USER_ID>", this.props.currentUser.userID);
    socket.on(key, (data) => {
      let sbr = data.sbrDetail;
      if (sbr) {
        let orignalAssignmentList = this.state.orignalAssignmentList;
        let existingSBROrignalIndex = orignalAssignmentList.findIndex((al) => al.singleBuyerRequestID == sbr.singleBuyerRequestID);
        if (existingSBROrignalIndex != -1) {
          orignalAssignmentList[existingSBROrignalIndex] = sbr
          this.setState({ orignalAssignmentList: orignalAssignmentList, assignmentList: this.generateAssignmentListData(orignalAssignmentList) });
        }
      }
    })

    key = SEND_INCOMING_MESSAGE_TO_AM_DASHBOARD.replace("<MANAGER_USER_ID>", this.props.currentUser.userID);
    socket.on(key, (data) => {
      let allMessagesFeed = this.state.allMessagesFeed;
      if (data) {
        let allAssignedSbrs = this.state.orignalAssignmentList.map((sbr) => { return sbr.singleBuyerRequestID });
        data.singleBuyerRequestID = _.orderBy(_.intersection(data.singleBuyerRequestID, allAssignedSbrs));
        allMessagesFeed = [data, ...allMessagesFeed];
        this.setState({ allMessagesFeed: [...allMessagesFeed] }, () => {
          const audio = new Audio(messageNotification);
          audio.play();
        })
      }
    })
  }

  onValidFormSubmit = async () => {
    const res = await getManagerAMDashboardData(this.state.momentDate.format('MM/DD/YYYY'));
    this.setState({ fetchedRecords: true });
    if (res.resStatus == 200) {
      const assignmentList = res.data.assignmentList;
      this.setState({
        allMessagesFeed: res.data.allMessagesFeed,
        assignmentList: this.generateAssignmentListData(assignmentList),
        orignalAssignmentList: assignmentList,
        loadHistoryData: !this.state.loadHistoryData
      });
    }
  }

  generateAssignmentListData = (assignmentList) => {
    let finalRequestList = {};
    if (assignmentList && assignmentList.length > 0) {
      let assignedSBRList = _.orderBy([...assignmentList], ['singleBuyerRequestID']);
      const totalRequestCount = assignedSBRList.length;
      const acceptedRequestCount = _.filter(assignedSBRList, sbr => sbr.isAccepted).length;
      const fillRate = Math.round((acceptedRequestCount / totalRequestCount) * 100);
      finalRequestList[this.props.currentUser.userID] = {
        fillRate: fillRate,
        totalRequestCount: totalRequestCount,
        requests: _.filter(assignedSBRList, sbr => !sbr.isAccepted),
        acceptedRequest: _.filter(assignedSBRList, sbr => sbr.isAccepted)
      };
    }
    return finalRequestList;
  }

  getAssignmentList = async () => {
    const res = await getManagerAMDashboardData();
    if (res.resStatus == 200) {
      const assignmentList = res.data;
      this.setState({ assignmentList: this.generateAssignmentListData(assignmentList) });
    }
  }

  onDeleteRequestClick = async (sbrID) => {
    const res = await unassignRequestFromManager(sbrID);
    if (res.resStatus == 200) {
      this.onValidFormSubmit();
    }
  }

  applyCssOnLabel = (sbr) => {
    const diff = moment().diff(moment(sbr.initiated), 'seconds');
    if (diff > 0 && diff <= 300) {
      return 'new';
    }
    else if (sbr.isAccepted) {
      return 'accepted';
    }
    return '';
  }

  getTimeStamp = (date) => {
    try {
      return moment(new Date(date)).format('MM/DD/YY HH:mm:ss');
    } catch (ex) {
      return "Invalid Date";
    }
  }

  handleRequestIDClick = (requestID) => {
    const win = window.open('/request/' + requestID, "_blank");
    win.focus();
  }

  onDateFocus = () => {
    this.setState({ showDatePicker: true });
  }

  onDateChange = (item) => {
    this.setState({ momentDate: moment(item), date: item, showDatePicker: false, disableShowButton: false });
  }

  handleClickOutside = (e) => {
    if (this.txtBoxRef.inputRef.current != e.target && !e.target.className.includes("rd") && !e.target.parentNode.className.includes("rd")) {
      this.setState({ showDatePicker: false });
    }
  }

  onDateTextChange = (e, data) => {
    if (data.value.length == 0) {
      this.setState({ disableShowButton: true });
    }
    else {
      this.setState({ disableShowButton: false });
    }
  }

  render() {
    return (
      <>
        <Container fluid className="am-dashboard-container">
          <div onClick={()=>{}} id={"main-page-panel-id"}  className="main-page-panel">
            <div className="content-panel">
              <div className="mobile-header">
                <div className="main-heading">
                  My Dashboard
                </div>
              </div>
            </div>
            <div className='content-panel'>
              <Formsy onValidSubmit={this.onValidFormSubmit} >
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8}>
                      <Grid.Row>
                        <Grid.Column width={3}>
                          <div className='date-picker-container'>
                            <DGTextbox
                              innerRef={(node) => {
                                this.txtBoxRef = node;
                              }}
                              onChange={this.onDateTextChange}
                              name="date"
                              placeholder="Choose date" l
                              abel="Select Date"
                              onFocus={this.onDateFocus}
                              value={this.state.momentDate.format("MM/DD/YYYY")} />

                            <div className='button-container'>
                              <button className='btn-primary' disabled={this.state.disableShowButton}>Show</button>
                            </div>

                            {this.state.showDatePicker && <Calendar onChange={this.onDateChange} minDate={this.state.minDate} date={this.state.date} />}
                          </div>
                        </Grid.Column>
                        <Grid.Column width={16}>
                          <div className={"messages-container-header"}>
                            <h2>
                              Recent Incoming Messages
                            </h2>
                          </div>
                          <div className={"messages-container"}>
                            {
                              this.state.allMessagesFeed.map((msg) => {
                                return (
                                  <>
                                    <div className={"request-messages"}>
                                      {
                                        <>
                                          <div className={`message-box ${msg.type == "outgoing" ? "right" : "left"}  ${msg.user == "buyer" ? "buyer" : "seller"}`}>
                                            <div className={"body"}>
                                              {msg.body}
                                            </div>
                                            <div className={"info-container"}>
                                              <div className={`user-tag ${msg.user == "buyer" ? "buyer" : "seller"}`}>
                                                {
                                                  msg.user == "buyer" ? "Buyer" : "Seller"
                                                }
                                              </div>
                                              <div className={`user-phone ${msg.type == "outgoing" ? "outgoing" : ""} ${msg.user == "buyer" ? "buyer" : "seller"}`}>
                                                {msg.type == "outgoing" ? msg.toPhone : msg.fromPhone}
                                              </div>
                                              <div className={`request-ids-container ${msg.type == "outgoing" ? "" : "incoming"}`}>
                                                <strong>
                                                  {"Request : "}
                                                </strong>
                                                {
                                                  msg.singleBuyerRequestID.map((ids) => {
                                                    return <div className={"request-id"} onClick={() => { this.handleRequestIDClick(ids) }} >
                                                      {ids + ","}
                                                    </div>
                                                  })
                                                }
                                              </div>
                                              <div className={"date-time-container"}>
                                                {this.getTimeStamp(msg.originalTextDate)}
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      }
                                    </div>
                                  </>
                                )
                              })
                            }
                            {
                              _.isEmpty(this.state.allMessagesFeed) ?
                                <div style={{ padding: "10px", fontWeight: "bold" }}>
                                  No Recent Message Found
                                </div>
                                : ""
                            }
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid.Column>
                    <Grid.Column width={8}>
                      <Grid.Row>
                        <Grid.Column width={16} style={{ paddingTop: "10px" }}>
                          {!_.isEmpty(this.state.assignmentList) && <Card.Group>
                            {
                              _.map(Object.keys(this.state.assignmentList), usr => {
                                return usr >= 0 && this.state.assignmentList[usr].requests && this.state.assignmentList[usr].requests.length > 0 && _.filter(this.state.assignmentList[usr].requests, r => !r.isAccepted).length > 0 && <Card>
                                  <Card.Content>
                                    <Card.Header className='card-header'>
                                      <div>
                                        {usr > 0 && <span>{this.state.assignmentList[usr].fillRate}% / </span>}
                                        <span>{this.state.assignmentList[usr].totalRequestCount}</span>
                                      </div>
                                    </Card.Header>
                                    <Card.Description>
                                      {_.map(this.state.assignmentList[usr].requests, req => {
                                        return <Label className={`request-label ${this.applyCssOnLabel(req)}`}>
                                          <a href={`/request/${req.singleBuyerRequestID}`} target="_blank">
                                            <div>{req.singleBuyerRequestID}</div>
                                            <div className='timestamp'>
                                              <div>{moment(req.initiated).format("HH:mm")}</div>
                                              {
                                                req.isAccepted ?
                                                  <div>{`${moment(req.acceptedOn).diff(moment(req.initiated), "minutes")} mins`}</div>
                                                  : ""
                                              }
                                            </div>
                                          </a>
                                        </Label>
                                      })
                                      }
                                    </Card.Description>
                                  </Card.Content>
                                </Card>
                              })
                            }
                          </Card.Group>
                          }
                        </Grid.Column>
                        <Grid.Column width={16}>
                          {!_.isEmpty(this.state.assignmentList) && <Card.Group>
                            {
                              _.map(Object.keys(this.state.assignmentList), usr => {
                                return usr >= 0 && this.state.assignmentList[usr].acceptedRequest && this.state.assignmentList[usr].acceptedRequest.length > 0 && _.filter(this.state.assignmentList[usr].acceptedRequest, r => r.isAccepted).length > 0 && <Card>
                                  <Card.Content>
                                    <Card.Description>
                                      {_.map(this.state.assignmentList[usr].acceptedRequest, req => {
                                        return <Label className={`request-label ${this.applyCssOnLabel(req)}`}>
                                          <a href={`/request/${req.singleBuyerRequestID}`} target="_blank">
                                            <div>{req.singleBuyerRequestID}</div>
                                            <div className='timestamp'>
                                              <div>{moment(req.initiated).format("HH:mm")}</div>
                                              {
                                                req.isAccepted ?
                                                  <div>{`${moment(req.acceptedOn).diff(moment(req.initiated), "minutes")} mins`}</div>
                                                  : ""
                                              }
                                            </div>
                                          </a>
                                        </Label>
                                      })
                                      }
                                    </Card.Description>
                                  </Card.Content>
                                </Card>
                              })
                            }
                          </Card.Group>
                          }
                        </Grid.Column>
                        <Grid.Column width={16}>
                          <Card.Group>
                            <Card>
                              <Card.Content>
                                <Card.Description>
                                  <ManagerRequestAssignmentHistory loadHistoryData={this.state.loadHistoryData} queryDate={this.state.momentDate.format('MM/DD/YYYY')} manager={this.props.currentUser} newAssignRequest={this.state.newAssignRequest} />
                                </Card.Description>
                              </Card.Content>
                            </Card>
                          </Card.Group>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Formsy>
            </div>
          </div>
        </Container>
      </>
    )
  }
}

function mapStateToProps({ auth }) {
  return {
    currentUser: auth.currentUser
  }
}

export default connect(mapStateToProps)(AMDashboardContainer);


